<template>
    <simple-dropdown :position="position">
        <template #trigger>
            <action-button
                icon="help"
                icon-before
                @mouseleave="useAutoHideLabel ? showLabel = false : ''"
                @mouseover="useAutoHideLabel ? showLabel = true : ''"
            >
                <div
                    class="flex items-center gap-6"
                    v-if="!hideLabel ? useAutoHideLabel ? showLabel : true : false"
                >
                    <p class="text-nowrap">{{ $t(buttonText) }}</p>
                    <svg-icon type="keyboard-arrow-down"/>
                </div>
            </action-button>
        </template>
        <template #content>
            <div class="w-400 p-12">
                <slot name="content"></slot>
            </div>
        </template>
    </simple-dropdown>
</template>

<script>
import SimpleDropdown from './SimpleDropdown.vue';
import SvgIcon from './SvgIcon.vue';
import ActionButton from "./ActionButton.vue";

export default {
    components: {ActionButton, SvgIcon, SimpleDropdown},
    props: {
        position: {
            type: String,
            validator: value => ['left', 'right', 'center', 'top'].includes(value),
            default: 'right',
        },
        hideLabel: Boolean, // Hide the label for the input by default
        useAutoHideLabel: {
            // Hide the label for the input by default
            type: Boolean,
            default: false,
        },
        onlyUseIcon: {
            // Only use icon, no border and button ux
            type: Boolean,
            default: false,
        },
        buttonText: {
            type: String,
            default: 'general.more_info',
        }
    },
    data: function () {
        return {
            showLabel: false,
        };
    },
};
</script>
